import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=8a5f6722&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a5f6722')) {
      api.createRecord('8a5f6722', component.options)
    } else {
      api.reload('8a5f6722', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=8a5f6722&", function () {
      api.rerender('8a5f6722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2faaTuQKO2l2D/JS/CurrentYear.vue"
export default component.exports